import { useQuery } from '@tanstack/react-query'
import { getUpcomingInvoices } from 'api/payment'
import { QueryOptions } from 'queries/types'
import { upcomingInvoicesKey } from './keys'

export function useUpcomingInvoices(
  companyId?: number,
  options: QueryOptions<typeof getUpcomingInvoices> = {}
) {
  return useQuery({
    ...options,
    queryKey: upcomingInvoicesKey(companyId),
    queryFn: ({ signal }) => {
      if (companyId === undefined) {
        throw new Error('Company is required')
      }
      return getUpcomingInvoices(companyId, signal)
    },
    enabled: companyId !== undefined && (options.enabled ?? true),
  })
}
